import Answer from "../../api/v2/models/answer"

export default Answer